const session = require('@flowio/session');

function getExperiment(key, defaultValue) {
  const experiments = session.getExperiments();

  if (experiments && experiments[key]) {
    return experiments[key];
  }

  return defaultValue;
}

function enabled(key) {
  const experiment = getExperiment(key, { enabled: false });
  return experiment.enabled === true;
}

module.exports = {
  enabled,
  getExperiment,
};



// WEBPACK FOOTER //
// ./static/js/v0/experiments.js